import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { GenericModal } from '../../modals';
import LoadingScreen from '../../loadings/LoadingScreen';

const Image = (props) => {
  const {
    alt,
    fullScreen,
    isLoading: isLoadingParent,
    maxWidth = 'sm',
    modalTitle,
    sx,
    src,
    zoom,
    onLoadedFallback,
    onError
  } = props;
  const [open, setOpen] = useState(false);
  const [isLoadingImage, setIsLoadingImage] = useState(true);
  const isLoading = isLoadingImage || isLoadingParent;
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!isLoadingParent && !src) {
      setIsLoadingImage(false);
    }
  }, [isLoadingParent, src]);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleClickZoom = () => {
    if (!zoom) {
      return;
    }

    setOpen(true);
  };

  const handleLoad = (e) => {
    if (e?.target) {
      const { naturalWidth, naturalHeight } = e.target;
      setSize({ width: naturalWidth, height: naturalHeight });
      if (onLoadedFallback) {
        onLoadedFallback(true);
      }
    }

    setIsLoadingImage(false);
  };

  const handleError = () => {
    setIsLoadingImage(false);
    onError?.();
  };

  return (
    <>
      {open && (
        <GenericModal
          fullScreen={fullScreen}
          maxWidth={maxWidth}
          showDownload
          title={modalTitle}
          url={src}
          open={open}
          handleClose={handleCloseModal}
        >
          <Image alt={alt} src={src} />
        </GenericModal>
      )}

      {isLoading && <LoadingScreen />}

      <Stack
        className="image-wrapper"
        sx={{ ...styleImageWrapper(isLoading, size, zoom), ...sx }}
        onClick={handleClickZoom}
      >
        <img alt={alt} src={src} onLoad={handleLoad} onError={handleError} />
      </Stack>
    </>
  );
};

const styleImageWrapper = (isLoading, size, zoom) => ({
  flexGrow: 1,
  display: isLoading ? 'none' : null, // * Image must be present in the DOM to trigger his onLoad event
  alignItems: 'center',
  justifyContent: 'center',
  ':hover': {
    cursor: zoom ? 'pointer' : 'default'
  },
  img: {
    maxHeight: size.height,
    maxWidth: size.width
    // TODO: Supprimer ces commentaires si le ratio est ok
    // height: 'auto',
    // width: 'auto'
  }
});

Image.propTypes = {
  alt: PropTypes.string,
  fullScreen: PropTypes.bool,
  isLoading: PropTypes.bool,
  maxWidth: PropTypes.string,
  modalTitle: PropTypes.string,
  src: PropTypes.string,
  sx: PropTypes.object,
  zoom: PropTypes.bool,
  onLoadedFallback: PropTypes.func,
  onError: PropTypes.func
};

export default Image;
